import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Switch } from 'react-router-dom';
import store, { history } from './redux';
import './constants/i18n';

import AppRoute from './AppRoute';
import Logout from './pages/logout';
import NotFound from './pages/not-found';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-datepicker/dist/react-datepicker.min.css';
import 'react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import './paper-dashboard.css';

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/logout" component={Logout} />
        <AppRoute />
        <Route component={NotFound} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js